<ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
{{ text }}
